













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import CaseModel, { InoutDebt, Warnings } from "@/models/CaseModel";
import SystemModel from "@/models/SystemModel";
import { NovaDepartment } from "@/models/CreditorModel";
import Currency from "@/components/currency.vue";
import PageNotAvailable from "@/components/page-not-available.vue";
import FormField from "@/components/AFormField.vue";
import DebtCollection from "@/components/icons/debt-collection.vue";
import Invoicing from "@/components/icons/invoicing.vue";
import Service from "@/components/icons/service.vue";
import RegisterCaseLayout from "./register-case-layout.vue";
import { getNames as getCountryNames } from "i18n-iso-countries";
import {
    RegisterCaseCustomer,
    RegisterCaseDebt,
    InoutCase,
    InoutCaseInput,
    InoutDebtClass,
    InoutDebtorClass,
    InoutHstAttClass,
    InoutCasesQuery,
    Query,
} from "@/models/CaseModel";
import { System } from "@/models/SystemModel";
import { UserModule } from "@/store/modules/User";
import dayjs from "dayjs";
import { extend } from "vee-validate";
import trackEvent from "@/plugins/track-event";
import debounce from "lodash/debounce";
import RegisterServiceCaseForm from "./aktiv-delgivning/register-service-case-form.vue";

function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
        return "0 Bytes";
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

interface InterestCodes {
    code: string;
    interestCode: string;
    translation: string;
}

interface CountryNames {
    countryCode: string;
    countryName: string;
}

interface DropFiles {
    hstId: string | null;
    file: File;
}

interface Error {
    error: any[];
    isError: boolean;
}

interface NovaTitles {
    countrycode: string;
    title: string;
}

interface InvoiceDescription {
    id: number;
    cType: string;
    description: string;
    extraInfoNeeded: boolean;
}

@Component({
    components: {
        Currency,
        FormField,
        RegisterCaseLayout,
        PageNotAvailable,
        DebtCollection,
        Invoicing,
        Service,
        RegisterServiceCaseForm,
    },
})
export default class RegisterCasesComponent extends Vue {
    registeredCases: InoutCase[] = [];
    customers: RegisterCaseCustomer[] = [];
    debts: RegisterCaseDebt[] = [];
    historyAttachments: InoutHstAttClass[] = [];
    systems: System[] = [];
    interestCodes: InterestCodes[] = [];
    novaDepartments: NovaDepartment[] = [];
    invoiceDescriptions: InvoiceDescription[] = [];
    dropFiles: DropFiles[] = [];
    dropFilesEditDeleted: DropFiles[] = [];
    system: System | null = null;
    historyInfo = "";
    yourReference: string | null = null;
    novaDepartment: NovaDepartment = {} as NovaDepartment;
    countries: CountryNames[] = [];
    novaTitles: NovaTitles[] = [];
    userModule = UserModule;
    systemModel = SystemModel;
    caseModel = CaseModel;
    systemNames: string[] = [];
    caseIdEdit: string | null = null;
    registeredCasesTotal = 0;
    activeCustomer = 0;
    activeDebt = 0;
    isLoadingRegister = false;
    isLoadingInterestCodes = false;
    isLoadingRegistered = true;
    isLoadingCreated = false;
    isLoadingFiles = false;
    isLoadingDepartments = false;
    isDropFilesModalActive = false;
    date: string | null = null;
    isOpen = false;
    errors: Error = { error: [], isError: false };
    editMode = false;
    creditorNameSearch = "";
    creditorNoSearch = "";
    countrySearch = "";
    warnings: Warnings = { invoiceNumber: "", capitalRemaining: "", capitalOriginal: "" };
    invoiceWarning: string | null = null;
    maxRegCapitalRemainingWarning: string | null = null;
    maxRegCapitalOriginalWarning: string | null = null;
    reset = false;
    fileTypes = [
        "application/pdf",
        "text/plain",
        "text/csv",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.oasis.opendocument.text",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/rtf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/xml",
        "text/xml",
    ];

    get customerRoles() {
        return {
            1: this.$t("registerCases.mainDebtor") as string,
            2: this.$t("registerCases.fellowApplicant") as string,
            3: this.$t("registerCases.bondsMan") as string,
        };
    }

    get customerTypes() {
        return [
            { name: this.$t("registerCases.private") as string, value: 1 },
            { name: this.$t("registerCases.firm") as string, value: 2 },
            { name: this.$t("registerCases.privateFirm") as string, value: 3 },
        ];
    }

    get hasAccessToADSystem() {
        return UserModule.hasAccessToADSystem;
    }

    @Prop(Object)
    query!: Query;

    async created(): Promise<void> {
        if (!this.isService) {
            trackEvent("pageView", this.$route.name as string);
            this.isLoadingRegister = true;
            if (!this.isMobile) {
                this.addCustomer();
                this.addDebt();
                this.sortCountries();
                await this.fetchRegisteredCases();
                await this.fetchDebtorTitles();
                this.isLoadingRegister = false;
                if (this.query.caseId) {
                    const editCase = this.registeredCases.find(item => item.caseId === this.query.caseId);
                    if (editCase) {
                        this.editMode = true;
                        this.mapToWeb(editCase);
                    }
                }
            }
        }

        extend("InvoiceNoUnique", {
            validate: async value => {
                if (UserModule.settings.checkInvoiceDuplicates === "1") {
                    this.invoiceWarning = null;
                    this.warnings.invoiceNumber = "";
                    this.registeredCases.forEach((i: InoutCase) => {
                        if (i.inoutDebt.find((d: InoutDebt) => d.kundNr === value)) {
                            this.invoiceWarning = this.$t("registerCases.invoiceDublicateToday") as string;
                            this.warnings.invoiceNumber = this.$t("registerCases.invoiceDublicateToday") as string;
                        }
                    });

                    if (!this.invoiceWarning) {
                        const { data } = await this.$api.graphql({
                            query: `query($id: [String], $invoiceNo: [String]) {
                                            cases (where: [{path: "systemCreditorId", value: $id}, {path: "info.externReference", value: $invoiceNo, comparison: contains}] ) { totalCount }
                                        }`,
                            variables: {
                                id: [this.novaDepartment.id.toString()],
                                invoiceNo: [value + ";"],
                            },
                        });
                        if (data.cases.totalCount > 0) {
                            this.invoiceWarning = this.$t("registerCases.invoiceDublicateDepartment") as string;
                            this.warnings.invoiceNumber = this.$t("registerCases.invoiceDublicateToday") as string;
                        }
                    }
                }

                return value.length > 0;
            },
        });

        extend("MaxRegCapitalRemaining", {
            validate: value => {
                this.maxRegCapitalRemainingWarning = null;
                this.warnings.capitalRemaining = "";
                if (this.system && value >= this.system.maxRegCapital) {
                    this.maxRegCapitalRemainingWarning = this.$t(
                        "registerCases.capitalRemainingMaxRegWarning"
                    ) as string;
                    this.warnings.capitalRemaining = this.$t("registerCases.capitalRemainingMaxRegWarning") as string;
                }

                return value >= 0;
            },
        });

        extend("MaxRegCapitalOriginal", {
            validate: value => {
                this.maxRegCapitalOriginalWarning = null;
                this.warnings.capitalOriginal = "";
                if (this.system && value >= this.system.maxRegCapital) {
                    this.maxRegCapitalOriginalWarning = this.$t("registerCases.capitalOriginalMaxRegWarning") as string;
                    this.warnings.capitalOriginal = this.$t("registerCases.capitalOriginalMaxRegWarning") as string;
                }

                return value >= 0;
            },
        });
    }

    checkDueDateMin(debt: RegisterCaseDebt) {
        const dueDatemin = this.invoiceDateAddDaysDue
            ? dayjs(debt.invoiceDate).add(this.invoiceDateAddDaysDue, "day")
            : dayjs(debt.invoiceDate).add(1, "day");
        if (dueDatemin.isAfter(dayjs(debt.invoiceDueDate))) {
            debt.invoiceDueDate = dueDatemin.toDate();
        }
    }

    setInvoiceDescription(debt: RegisterCaseDebt, invoiceDescription: InvoiceDescription) {
        debt.invoiceDescription = invoiceDescription.description;
        debt.extraInfoNeeded = invoiceDescription.extraInfoNeeded;
    }

    @Watch("creditorKtyp")
    cTypeChange() {
        if (this.ctypeIsProperty) {
            this.fetchInvoiceDescriptions("fastighet");
        }
    }

    get langCode() {
        return UserModule.settings.language;
    }

    get isService() {
        return UserModule.isService;
    }

    get ctypeIsProperty() {
        return this.creditorKtyp.toLowerCase().includes("fastighet");
    }

    get creditorKtyp() {
        if (Object.keys(this.novaDepartment).length) {
            if (this.novaDepartment.novaCreditor.length) {
                return this.novaDepartment.novaCreditor[0].cType ?? "";
            }
        }
        return "";
    }

    get showFee() {
        if (UserModule.settings.showFee) {
            return this.system && this.system.showFee && this.userModule.settings.showFee === "1";
        }

        return this.system && this.system.showFee;
    }

    get maxFee() {
        if (this.system && this.system.maxFee > -1) {
            return { min: 0, max: this.system.maxFee };
        }

        return { min: 0 };
    }

    get maxRegCapital() {
        if (this.system && this.system.maxRegCapital > -1) {
            return { min: 0, max: this.system.maxRegCapital };
        }

        return { min: 0 };
    }

    get invoiceDateMax() {
        if (this.invoiceDateAddDays) {
            return dayjs(new Date()).add(this.invoiceDateAddDays, "day").toDate();
        }

        return dayjs(new Date()).toDate();
    }

    dueDateMin(invoiceDate: Date) {
        if (this.invoiceDateAddDaysDue) {
            return dayjs(invoiceDate).add(this.invoiceDateAddDaysDue, "day").toDate();
        }

        return dayjs(invoiceDate).add(1, "day").toDate();
    }

    get invoiceDateAddDays() {
        return Number(UserModule.settings.invoiceDateAddDays);
    }

    get invoiceDateAddDaysDue() {
        return Number(UserModule.settings.invoiceDateAddDaysDue);
    }

    get isMobile() {
        return UserModule.isMobileGlobal;
    }

    get debtorTitleActive() {
        if (this.system) {
            switch (this.system.country.countryName) {
                case "DE":
                    return true;
                case "AT":
                    return true;
                case "NL":
                    return true;
                case "FR":
                    return true;
                case "CH":
                    return true;
                default:
                    return false;
            }
        }

        return false;
    }

    get postalCodeTwo() {
        if (this.system) {
            switch (this.system.country.countryName) {
                case "PL":
                    return true;
                case "NL":
                    return true;
                case "FR":
                    return true;
                case "ES":
                    return true;
                default:
                    return false;
            }
        }

        return false;
    }

    get province() {
        if (this.system) {
            switch (this.system.country.countryName) {
                case "NL":
                    return true;
                case "ES":
                    return true;
                default:
                    return false;
            }
        }

        return false;
    }

    get debtorTitles() {
        if (this.system) {
            switch (this.system.country.countryName) {
                case "DE":
                    return this.novaTitles.filter(t => t.countrycode === "DE");
                case "AT":
                    return this.novaTitles.filter(t => t.countrycode === "AT");
                case "NL":
                    return this.novaTitles.filter(t => t.countrycode === "NL");
                case "FR":
                    return this.novaTitles.filter(t => t.countrycode === "FR");
                case "CH":
                    return this.novaTitles.filter(t => t.countrycode === "CH");
                default:
                    return [];
            }
        }

        return [];
    }

    get todaysDate() {
        return new Date();
    }

    get isLoadingSystems() {
        return this.userModule.systems.length === 0;
    }

    get filteredDepartments() {
        return this.novaDepartments.filter(
            dep => dep.creditorNo.toString() + "," + dep.departmentNo.toString() + ": " + dep.creditorName.toLowerCase()
        );
    }

    get filteredCountries() {
        return this.countries.filter(c => c.countryName.toLowerCase().includes(this.countrySearch.toLowerCase()));
    }

    get dropFilesModel() {
        if (this.dropFiles.length > 0) {
            const files: File[] = this.dropFiles.map(d => d.file);

            return files;
        }

        return [];
    }

    set dropFilesModel(files: File[]) {
        const newFiles = files.slice(this.dropFiles.length);
        const fileList: DropFiles[] = newFiles.map(file => {
            return {
                hstId: null,
                file,
            };
        });
        this.dropFiles.push(...fileList);

        if (
            this.dropFiles.some(
                file => file.file.size > 10000000 || !this.dropFiles.some(dropFile => this.validFileType(dropFile.file))
            )
        ) {
            this.isDropFilesModalActive = true;
        }
    }

    get selectedInterestCode() {
        return this.interestCodes.find(i => i.interestCode === this.debts[this.activeDebt].interestCode)?.translation;
    }

    dropFileErrorLabel(file: File) {
        const sizeMsg = file.size > 10000000 ? this.$t("registerCases.fileTooLarge") : "";
        const typeMsg = !this.validFileType(file) ? this.$t("registerCases.fileNotSupported") : "";

        return sizeMsg + " " + typeMsg;
    }

    dropFileErrorLabelTwo(file: File) {
        const sizeMsg = file.size > 10000000 ? this.$t("registerCases.fileSize") : "";
        const typeMsg = !this.validFileType(file) ? this.$t("registerCases.fileType") : "";

        return sizeMsg + " " + typeMsg;
    }

    dropfilesModalOk() {
        this.dropFiles = this.dropFiles.filter(dropFile => dropFile.file.size < 10000001); // remove files larger than 10MB
        this.dropFiles = this.dropFiles.filter(dropFile => this.validFileType(dropFile.file)); // remove files with invalid type
        this.isDropFilesModalActive = false;
    }

    validFileType(file: File) {
        return this.fileTypes.includes(file.type);
    }

    async deleteDropFile(index: number): Promise<void> {
        if (this.dropFiles[index].hstId) {
            this.dropFilesEditDeleted.push(this.dropFiles[index]);
        }
        this.dropFiles.splice(index, 1);
    }

    @Watch("system")
    systemChange(system: System | null): void {
        this.novaDepartment = {} as NovaDepartment;
        this.debts.forEach(item => {
            item.invoiceDescription = null;
            item.interestRate = null;
            item.interestCode = null;
        });
        this.fetchInterestCodes();
        if (system) {
            this.fetchNovaDepartments(system);
            this.customers[0].countryCode = system.country.countryName;
        }
    }

    @Watch("query.perPage")
    @Watch("query.currentPage")
    queryUpdatedActive(): void {
        this.fetchRegisteredCases();
    }

    onCreditorNameSearchInput = debounce((value: string) => this.updateCreditorName(value), 600);
    onCreditorNoSearchInput = debounce((value: string) => this.updateCreditorNo(value), 600);

    updateCreditorName(value: string) {
        this.creditorNameSearch = value;
        this.fetchNovaDepartments(this.system!);
    }

    updateCreditorNo(value: string) {
        this.creditorNoSearch = value;
        this.fetchNovaDepartments(this.system!);
    }

    reseted() {
        this.reset = false;
    }

    defaultValues(novaDepartment: NovaDepartment) {
        for (let index = 0; index < this.debts.length; index++) {
            this.debts[index].invoiceDescriptionExtra = "";
            if (novaDepartment.description) {
                this.debts[index].invoiceDescription =
                    novaDepartment.description == "" ? null : novaDepartment.description;
            } else {
                this.debts[index].invoiceDescription = null;
            }
            if (novaDepartment.interestRate) {
                this.debts[index].interestRate = novaDepartment.interestRate;
            } else {
                this.debts[index].interestRate = null;
            }
            if (novaDepartment.interestCode) {
                const interestCode = this.interestCodes.find(item => item.interestCode === novaDepartment.interestCode);
                const code = interestCode ? interestCode.interestCode : null;
                this.debts[index].interestCode = code;
            } else {
                this.debts[index].interestCode = null;
            }
        }
    }

    sortCountries() {
        const countryNames = getCountryNames(this.userModule.settings.language.substring(0, 2));
        const countryKeys: string[] = Object.keys(countryNames);
        const countryValues: string[] = Object.values(countryNames);

        let commonCountries: CountryNames[] = [];
        let unCommonCountries: CountryNames[] = [];
        for (let index = 0; index < countryKeys.length; index++) {
            let item = { countryCode: countryKeys[index], countryName: countryValues[index] } as CountryNames;
            switch (countryKeys[index]) {
                case "AT":
                    commonCountries.push(item);
                    break;
                case "CS":
                    commonCountries.push(item);
                    break;
                case "DK":
                    commonCountries.push(item);
                    break;
                case "EE":
                    commonCountries.push(item);
                    break;
                case "FI":
                    commonCountries.push(item);
                    break;
                case "FR":
                    commonCountries.push(item);
                    break;
                case "DE":
                    commonCountries.push(item);
                    break;
                case "HU":
                    commonCountries.push(item);
                    break;
                case "IT":
                    commonCountries.push(item);
                    break;
                case "NL":
                    commonCountries.push(item);
                    break;
                case "NO":
                    commonCountries.push(item);
                    break;
                case "PL":
                    commonCountries.push(item);
                    break;
                case "SK":
                    commonCountries.push(item);
                    break;
                case "ES":
                    commonCountries.push(item);
                    break;
                case "SE":
                    commonCountries.push(item);
                    break;
                default:
                    unCommonCountries.push(item);
                    break;
            }
        }
        this.countries.push(...commonCountries);
        this.countries.push(...unCommonCountries);
    }

    sumCapital(inoutDebts: InoutDebt[]) {
        const capitals = inoutDebts.map(debt => (debt.restKapital ? debt.restKapital : 0));
        const fees = inoutDebts.map(debt => (debt.restAvgift ? debt.restAvgift : 0));
        const interests = inoutDebts.map(debt => (debt.restRanta ? debt.restRanta : 0));
        const capital = capitals.reduce((acc: number, val: number): number => acc + val);
        const fee = fees.reduce((acc: number, val: number): number => acc + val);
        const interest = interests.reduce((acc: number, val: number): number => acc + val);

        return capital + fee + interest;
    }

    formatBytes(bytes: number) {
        return formatBytes(bytes);
    }

    onPageChangeActive(page: number) {
        this.query.currentPage = page;
    }

    getSystem(systemName: string) {
        return this.userModule.systems.filter(s => s.systemName === systemName)[0];
    }

    setDate(date: Date) {
        this.date = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
    }

    formatDate(date: Date) {
        return dayjs(date).format("YYYY-MM-DD");
    }

    formatDateTime(date: Date) {
        return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
    }

    formatDateTimeDisplay(date: Date) {
        return `${this.$format.date(date)} ${this.$format.time(date)}`;
    }

    chooseCustomer(index: number) {
        this.activeCustomer = index;
    }

    chooseDebt(index: number) {
        this.activeDebt = index;
    }

    deleteCustomer(index: number) {
        this.chooseCustomer(index - 1);
        setTimeout(() => {
            this.customers.splice(index, 1);
        });
        this.$buefy.toast.open(this.$t("registerCases.customerDeleted") as string);
    }

    deleteDebt(index: number) {
        this.chooseDebt(index - 1);
        setTimeout(() => {
            this.debts.splice(index, 1);
        });
        this.$buefy.toast.open(this.$t("registerCases.debtDeleted") as string);
    }

    async fetchDebtorTitles() {
        try {
            const { data } = await this.$api.graphql({
                query: `query($first: Int) {
                        novaTitles(first: $first) {
                            items {
                                countrycode
                                title
                            }
                        }
                    }`,
                variables: {
                    first: 999,
                },
            });
            this.novaTitles = data.novaTitles.items;
        } catch (error) {
            this.$notifications.error({ message: this.$t("registerCases.fetchTitlesFail") as string });
            this.errors.error.push(error);
            this.errors.isError = true;
            this.$apm.captureError(error as any);
        }
    }

    async fetchNovaDepartments(system: System) {
        this.isLoadingDepartments = true;
        try {
            const { data } = await this.$api.graphql({
                query: `query($first: Int, $where: [WhereExpressionGraph]) {
                        novaDepartments(first: $first, where: $where) {
                            items {
                                id
                                novaCreditorDataId
                                collector
                                countryCode
                                interestCode
                                interestRate
                                systemId
                                creditorName
                                creditorNo
                                departmentNo
                                description
                                termsOfpayment
                                termsOfInterest
                                novaCreditor {
                                    creditorName
                                    creditorNo
                                    departmentNo
                                    creditorDescription
                                    cType
                                }
                            }
                        }
                    }`,
                variables: {
                    first: 999,
                    where: [
                        { path: "systemId", value: system.systemId.toString() },
                        { path: "departmentNo", value: "0", negate: true },
                        ...(this.creditorNameSearch
                            ? [{ path: "creditorName", comparison: "contains", value: this.creditorNameSearch }]
                            : []),
                        ...(this.creditorNoSearch ? [{ path: "creditorNo", value: this.creditorNoSearch }] : []),
                        {
                            groupedExpressions: [
                                {
                                    path: "creditorNo",
                                    comparison: "greaterThanOrEqual",
                                    value: "7000",
                                    negate: true,
                                    connector: "or",
                                },
                                { path: "creditorNo", comparison: "lessThan", value: "8000", negate: true },
                            ],
                        },
                        {
                            groupedExpressions: [
                                {
                                    path: "creditorNo",
                                    comparison: "greaterThanOrEqual",
                                    value: "9000",
                                    negate: true,
                                    connector: "or",
                                },
                                { path: "creditorNo", comparison: "lessThan", value: "10000", negate: true },
                            ],
                        },
                    ],
                },
            });

            this.novaDepartments = data.novaDepartments.items;
            this.isLoadingDepartments = false;
        } catch (error) {
            this.isLoadingDepartments = false;
            this.$notifications.error({ message: this.$t("registerCases.fetchDepartmentsFail") as string });
            this.errors.error.push(error);
            this.errors.isError = true;
            this.$apm.captureError(error as any);
        }
    }

    async fetchInvoiceDescriptions(ctype: string) {
        try {
            const { data } = await this.$api.graphql({
                query: `query($first: Int, $where: [WhereExpressionGraph]) {
                        invoiceDescription(first: $first, where: $where) {
                            items {
                                id
                                cType
                                description
                                extraInfoNeeded
                            }
                        }
                    }`,
                variables: {
                    first: 99,
                    where: [{ path: "cType", value: ctype }],
                },
            });

            this.invoiceDescriptions = data.invoiceDescription.items;
        } catch (error) {
            this.$notifications.error({ message: this.$t("registerCases.fetchInvoiceDescriptionFail") as string });
            this.errors.error.push(error);
            this.errors.isError = true;
            this.$apm.captureError(error as any);
        }

        this.isLoadingDepartments = false;
    }

    async fetchInterestCodes() {
        this.isLoadingInterestCodes = true;

        try {
            const { data } = await this.$api.graphql({
                query: `query($sites: String) {
                        interestCodes(site: $sites) {
                            code
                            interestCode
                        }
                    }`,
                variables: {
                    sites: this.system?.systemName,
                },
            });

            const interestCodes = data.interestCodes.map((item: { code: string; interestCode: string }) => {
                const code = item.code;
                const interestCode = item.interestCode;
                const translation = this.userModule.externalTranslations.INTEREST[item.code];

                return {
                    code,
                    interestCode,
                    translation,
                } as unknown as InterestCodes;
            });

            this.interestCodes = interestCodes.filter((x: InterestCodes) => x.interestCode !== "");
        } catch (error) {
            this.$notifications.error({ message: this.$t("registerCases.fetchInterestCodesFail") as string });
            this.errors.error.push(error);
            this.errors.isError = true;
            this.$apm.captureError(error as any);
        }

        this.isLoadingInterestCodes = false;
    }

    async fetchRegisteredCases() {
        this.isLoadingRegistered = true;
        try {
            const { data } = await this.$api.graphql(
                InoutCasesQuery(this.query, [{ path: "isDeleted", value: "0" }], [{ path: "rowId", descending: true }])
            );

            // console.log("registered cases: ", data);
            this.registeredCases = data.inoutCases.items;
            this.registeredCasesTotal = data.inoutCases.totalCount;
        } catch (error) {
            this.$notifications.error({ message: this.$t("registerCases.fetchRegCasesFail") as string });
            this.$apm.captureError(error as any);
        }

        this.isLoadingRegistered = false;
    }

    async deleteCase(caseId: string) {
        try {
            await this.$api.graphql({
                query: `mutation($caseId: String!) {
                                deleteInoutCase(caseId: $caseId) {
                                    caseId
                                }
                            }`,
                variables: { caseId },
            });

            this.$notifications.success({
                message: this.$t("registerCases.deleteCaseSuccess", { caseId }) as string,
            });

            this.fetchRegisteredCases();
        } catch (error) {
            this.$notifications.error({ message: this.$t("registerCases.deleteCaseFail") as string });
            this.$apm.captureError(error as any);
        }
    }

    async saveCase() {
        this.isLoadingRegister = true;
        try {
            const { data } = await this.$api.graphql({
                query: `mutation($newcase: InOutCaseInput!, $caseId: String) {
                        addCase(newcase: $newcase, caseId: $caseId) {
                            success
                        }
                    }`,
                variables: {
                    newcase: await this.mapToInoutCaseInput(),
                    caseId: this.editMode ? this.caseIdEdit : null,
                },
            });

            if (this.editMode) {
                this.$notifications.success({ message: this.$t("registerCases.editCaseSuccess") as string });
            } else {
                this.$notifications.success({ message: this.$t("registerCases.createCaseSuccess") as string });
            }

            if (this.dropFiles.length > 0) {
                await this.saveFiles(data.addCase[0].success);
            }

            if (this.editMode) {
                this.$router.replace({
                    name: "register-case",
                });
            }

            trackEvent("register", "newcase", data.addCase[0].success);
            this.fetchRegisteredCases();
            this.clearAllFields();
            this.isLoadingRegister = false;
        } catch (error) {
            this.isLoadingRegister = false;
            if (this.editMode) {
                this.$notifications.error({ message: this.$t("registerCases.editCaseFail") as string });
            } else {
                this.$notifications.error({ message: this.$t("registerCases.createCaseFail") as string });
            }
            this.$apm.captureError(error as any);
        }
    }

    async saveFiles(caseId: string) {
        this.dropFiles = this.dropFiles.filter(dropFile => dropFile.file.size < 10000001); // remove files larger than 10MB
        this.dropFiles = this.dropFiles.filter(dropFile => !dropFile.hstId); // remove already downloaded files

        if (this.dropFiles.length > 0) {
            try {
                this.isLoadingFiles = true;

                const data = new FormData();
                data.append("caseId", caseId);

                this.dropFiles.forEach(dropFile => {
                    data.append("files", dropFile.file);
                });

                await this.$api.post("file/inoutcaseattachments", data, {
                    headers: {
                        "Content-Type": "multipart/form-data; boundary=something",
                        Authorization: "Bearer " + UserModule.token,
                    },
                });

                //this.dropFiles = [];
                this.$notifications.success({ message: this.$t("registerCases.attachFilesSuccess") as string });
                this.isLoadingFiles = false;
            } catch (error) {
                this.$notifications.error({ message: this.$t("registerCases.attachFilesFail") as string });
                this.isLoadingFiles = false;

                throw error;
            }
        }
    }

    async mapToWeb(caseData: InoutCase): Promise<void> {
        // when a user edits a case, this function populates all fields
        this.isLoadingRegister = true;
        this.editMode = true;

        this.creditorNoSearch = caseData.kliNr as string;
        this.system = this.getSystem(caseData.site);
        await this.fetchNovaDepartments(this.system);
        await this.fetchInterestCodes();
        const department = this.novaDepartments.find(item => item.id === caseData.reggedCwcreditorId);
        this.novaDepartment = department ? department : ({} as NovaDepartment);
        this.yourReference = caseData.refNr;
        this.historyInfo = caseData.historik;
        this.caseIdEdit = caseData.caseId;

        this.customers.splice(0, this.customers.length);

        for (let index = 0; index < caseData.inoutDebtor.length; index++) {
            this.addCustomer();

            this.customers[index].id = caseData.inoutDebtor[index].idNr;
            this.customers[index].title = caseData.inoutDebtor[index].title;
            this.customers[index].firstName = caseData.inoutDebtor[index].fnamn;
            this.customers[index].lastName = caseData.inoutDebtor[index].enamn;
            this.customers[index].customerRole = caseData.inoutDebtor[index].gldTyp;
            this.customers[index].customerType = caseData.inoutDebtor[index].extTyp;
            this.customers[index].countryCode = caseData.inoutDebtor[index].landskod;
            this.customers[index].address = caseData.inoutDebtor[index].adr2;
            this.customers[index].province = caseData.inoutDebtor[index].provins;
            this.customers[index].postalCode = caseData.inoutDebtor[index].postNr;
            this.customers[index].postalCode2 = caseData.inoutDebtor[index].postNr2;
            this.customers[index].city = caseData.inoutDebtor[index].postOrt;
            this.customers[index].companyName = caseData.inoutDebtor[index].foretagNamn;
            this.customers[index].coAddress =
                caseData.inoutDebtor[index].extTyp === 1 ? caseData.inoutDebtor[index].adr1 : "";
            this.customers[index].contactPerson =
                caseData.inoutDebtor[index].extTyp !== 1 ? caseData.inoutDebtor[index].adr1 : null;
            this.customers[index].primaryPhone = caseData.inoutDebtor[index].telefon;
            this.customers[index].secondaryPhone = caseData.inoutDebtor[index].teleovr;
            this.customers[index].email = caseData.inoutDebtor[index].email;
            this.customers[index].giroNo = caseData.inoutDebtor[index].giroNr;
        }

        this.debts.splice(0, this.debts.length);

        for (let index = 0; index < caseData.inoutDebt.length; index++) {
            this.addDebt();

            this.debts[index].invoiceDate = new Date(caseData.inoutDebt[index].faktDat);
            this.debts[index].invoiceDueDate = new Date(caseData.inoutDebt[index].forfDag);
            this.debts[index].invoiceDescription = caseData.inoutDebt[index].avser?.split("--")[0] ?? "";
            this.debts[index].invoiceDescriptionExtra = caseData.inoutDebt[index].avser?.split("--")[1] ?? "";
            this.debts[index].invoiceNumber = caseData.inoutDebt[index].kundNr;
            this.debts[index].remainingCapital = caseData.inoutDebt[index].restKapital;
            this.debts[index].remainingFee = caseData.inoutDebt[index].restAvgift;
            this.debts[index].interestRate = caseData.inoutDebt[index].ranteSats;
            this.debts[index].remainingInterest = caseData.inoutDebt[index].restRanta;
            this.debts[index].originalCapital = caseData.inoutDebt[index].orgKapital;
            this.debts[index].ocr = caseData.inoutDebt[index].kundNr2;
            this.debts[index].interestCode = caseData.inoutDebt[index].ranteKod;

            // Additional debt information
            // Parking
            this.debts[index].plateNumber = caseData.inoutDebt[index].parkRegNr;
            this.debts[index].vehicleType = caseData.inoutDebt[index].parkFordonTyp;
            this.debts[index].violation = caseData.inoutDebt[index].parkOvertradelse;
            this.debts[index].parkTime = ((tid: string | null) => {
                return tid ? new Date(tid) : null;
            })(caseData.inoutDebt[index].parkKontrollTid);
            this.debts[index].violationAddress = caseData.inoutDebt[index].parkKontrollAdress;
            // Real estate
            this.debts[index].objectNumber = caseData.inoutDebt[index].lghNr;
            this.debts[index].objectAddress = caseData.inoutDebt[index].objAdr;
            this.debts[index].squareMeter = caseData.inoutDebt[index].storLek;
            // Loan
            this.debts[index].promissoryNote = caseData.inoutDebt[index].reversNr;
        }

        const dropFiles: DropFiles[] = caseData.inoutHstAtt.map(file => {
            return {
                hstId: file.hstAttId,
                file: new File(["edit"], file.fileName, { type: file.fileExtension }),
            } as unknown as DropFiles;
        });

        this.dropFiles = dropFiles;
        this.isLoadingRegister = false;
    }

    async mapToInoutCaseInput() {
        const newcase: InoutCaseInput = {} as InoutCaseInput;

        newcase.site = this.system!.systemName;
        newcase.departmentNo = this.novaDepartment.departmentNo;
        newcase.referenceNo = this.yourReference!;
        newcase.caseId = "1"; // gets overwritten with a GUID value in API
        newcase.creditorNo = this.novaDepartment.creditorNo;
        newcase.historyInfo = this.historyInfo;
        newcase.reggedCWCreditorId = this.novaDepartment.id;
        newcase.reggedCWCreditorName = this.novaDepartment.creditorName;
        newcase.reggedBy = UserModule.fullName;
        newcase.reggedAt = this.todaysDate;

        newcase.inoutDebtor = this.customers.map((debtor, index) => {
            return {
                idNo: debtor.id,
                title: debtor.title,
                firstName: debtor.firstName,
                lastName: debtor.lastName,
                companyName: debtor.companyName,
                debtorId: index + 1, // gets overwritten with a GUID value in API
                debtorType: debtor.customerRole,
                extType: debtor.customerType,
                countryCode: debtor.countryCode,
                addr2: debtor.address,
                province: debtor.province,
                cityCode: debtor.postalCode,
                cityCode2: debtor.postalCode2,
                city: debtor.city,
                addr1: debtor.contactPerson ? debtor.contactPerson : debtor.coAddress,
                phoneHome: debtor.primaryPhone,
                phoneCell: debtor.secondaryPhone,
                email: debtor.email,
                giroNr: debtor.giroNo,
            } as unknown as InoutDebtorClass;
        });

        newcase.inoutDebt = this.debts.map((debt, index) => {
            return {
                invoiceDate: this.formatDate(debt.invoiceDate ? debt.invoiceDate : this.todaysDate),
                dueDay: this.formatDate(debt.invoiceDueDate ? debt.invoiceDueDate : this.todaysDate),
                debtId: index + 1, // gets overwritten with a GUID value in API
                customerNo: debt.invoiceNumber,
                description:
                    debt.invoiceDescription +
                    (debt.invoiceDescriptionExtra ? debt.invoiceDescription + "--" + debt.invoiceDescriptionExtra : ""),
                remainingCapital: debt.remainingCapital?.toString(),
                remainingFee: debt.remainingFee?.toString(),
                interestRate: debt.interestRate?.toString(),
                remainingInterest: debt.remainingInterest?.toString(),
                originalCapital: debt.originalCapital?.toString(),
                ocrNr: debt.ocr,
                interestCode: debt.interestCode,

                // Additional debt information
                // Parking
                parkRegNr: debt.plateNumber,
                parkFordonTyp: debt.vehicleType,
                parkOvertradelse: debt.violation,
                parkKontrollTid: debt.parkTime ? this.formatDateTime(debt.parkTime) : null,
                parkKontrollAdress: debt.violationAddress,
                // Real estate
                objectNo: debt.objectNumber,
                objectAddress: debt.objectAddress,
                objectArea: debt.squareMeter,
                // Loan
                reversNr: debt.promissoryNote,
            } as unknown as InoutDebtClass;
        });

        if (this.editMode && this.dropFilesEditDeleted.length > 0) {
            // These files will get deleted in db, the actual uploads are done in function: 'saveFiles'
            const hstAtts: InoutHstAttClass[] = this.dropFilesEditDeleted.map(dropFile => {
                const hstatt = {
                    attachmentId: dropFile.hstId,
                    fileName: dropFile.file.name,
                    fileExtension: dropFile.file.type,
                    file: "editDelete",
                } as unknown as InoutHstAttClass;

                return hstatt;
            });
            newcase.inoutHstAtt = hstAtts;
        }

        return newcase;
    }

    confirmClearAllFields() {
        this.$buefy.dialog.confirm({
            title: this.$t("registerCases.clearAll") as string,
            message: this.$t("registerCases.clearAllMessage") as string,
            cancelText: this.$t("registerCases.cancel") as string,
            confirmText: "Ok",
            type: "is-success",
            onConfirm: () => {
                this.clearAllFields();
                this.$buefy.toast.open(this.$t("registerCases.clearAllSuccess") as string);
            },
        });
    }

    editCase(index: number) {
        this.mapToWeb(this.registeredCases[index]);
    }

    confirmDeleteCase(caseId: string) {
        this.$buefy.dialog.confirm({
            title: this.$t("registerCases.deleteCaseTitle") as string,
            message: this.$t("registerCases.deleteCaseMessage") as string,
            cancelText: this.$t("registerCases.cancel") as string,
            confirmText: "Ok",
            type: "is-success",
            onConfirm: () => {
                this.deleteCase(caseId);
            },
        });
    }

    addCustomer() {
        const customerRole = this.customers.length === 0 ? 1 : 2;
        const countryCode = this.customers.length > 0 ? this.system?.country.countryName : "";

        this.customers.push({
            id: "",
            title: null,
            firstName: null,
            lastName: "",
            companyName: "",
            contactPerson: "",
            customerType: null,
            customerRole,
            countryCode: countryCode!,
            address: null,
            province: null,
            postalCode: "",
            postalCode2: null,
            city: "",
            coAddress: "",
            primaryPhone: "",
            secondaryPhone: "",
            email: "",
            giroNo: "",
        });
        setTimeout(() => {
            this.chooseCustomer(this.customers.length - 1);
        });
    }

    addDebt() {
        const findInterestCode = () => {
            const interestCode = this.interestCodes.find(
                item => item.interestCode === this.novaDepartment.interestCode
            );

            return interestCode ? interestCode.interestCode : null;
        };

        const invoiceDate = this.invoiceDateAddDays
            ? dayjs(new Date()).add(this.invoiceDateAddDays, "day").startOf("day").toDate()
            : dayjs(new Date()).startOf("day").toDate();
        this.debts.push({
            invoiceDate,
            invoiceDueDate: this.invoiceDateAddDaysDue
                ? dayjs(invoiceDate).add(this.invoiceDateAddDaysDue, "day").startOf("day").toDate()
                : dayjs(invoiceDate).add(1, "day").startOf("day").toDate(),
            invoiceNumber: "",
            invoiceDescription: this.novaDepartment.description ? this.novaDepartment.description : null,
            invoiceDescriptionExtra: "",
            extraInfoNeeded: false,
            remainingCapital: null,
            remainingFee: null,
            interestRate: this.novaDepartment.interestRate ? this.novaDepartment.interestRate : null,
            remainingInterest: null,
            originalCapital: null,
            ocr: "",
            interestCode: findInterestCode(),
            plateNumber: null,
            vehicleType: null,
            violation: null,
            parkTime: null,
            violationAddress: null,
            objectNumber: null,
            objectAddress: null,
            squareMeter: null,
            promissoryNote: null,
        });
        setTimeout(() => {
            this.chooseDebt(this.debts.length - 1);
        });
    }

    clearAllFields() {
        this.customers.splice(0, this.customers.length);
        this.addCustomer();
        this.debts.splice(0, this.debts.length);
        this.addDebt();
        this.system = null;
        this.yourReference = "";
        this.historyInfo = "";
        this.novaDepartment = {} as NovaDepartment;
        this.dropFiles = [];
        this.editMode = false;

        setTimeout(() => {
            this.reset = true;
            // const observer: any = this.$refs.observer;
            // observer.reset();
        });
    }
}
